import { appApi } from '@web/app/store/api'
import { IChangePasswordRequest, IChangePasswordResponse, IProfileResponse } from '../types'

export const profileApi = appApi.injectEndpoints({
  endpoints: (builder) => ({

    changePassword: builder.mutation<IChangePasswordResponse, IChangePasswordRequest>({
      query: (body) => ({
        url: '/api/v1/users/change-password',
        method: 'POST',
        body,
      }),
      // "Invalida" el perfil, forzando un refresco automático
      invalidatesTags: ['Profile'], 
    }),

    getProfile: builder.query<IProfileResponse, void>({
      query: () => ({
        url: '/api/v1/users/profile',
        method: 'GET',
      }),
      providesTags: ['Profile'],
      keepUnusedDataFor: 0,
    }),

    sendEmailOtp: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: '/api/v1/auth/email/send-otp',
        method: 'POST',
      }),
    }),

    verifyEmailOtp: builder.mutation<{ message: string }, { code: string }>({
      query: (body) => ({
        url: '/api/v1/auth/email/verify-otp',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useChangePasswordMutation,
  useGetProfileQuery,
  useSendEmailOtpMutation,
  useVerifyEmailOtpMutation,
} = profileApi